// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-rewriter.js?id=data-v-1ee52cbe&scoped=true!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/app/layouts/default/default.vue
// module id = 914
// module chunks = 61